// It is preferred to show few appointments previously booked rather than zero
const backupNumber = Math.round(Math.random() * 15) + 5;

// Function to Determine Booked By Number to Display
// if bookedByPastMonth is 0 or null return backupNumber
// if bookedByPastMonth is between 1 and 5 return bookedByPastMonth  * 3
// if bookedByPastMonth is between 6 and 10 return bookedByPastMonth * 2
// if bookedByPastMonth is between 11 and 15 return bookedByPastMoonth
export const getBookedByNumberToDisplay = (bookedByPastMonth) => {
  if (!bookedByPastMonth) {
    return backupNumber;
  }
  if (bookedByPastMonth > 0 && bookedByPastMonth < 6) {
    return bookedByPastMonth * 3;
  }
  if (bookedByPastMonth > 5 && bookedByPastMonth < 11) {
    return bookedByPastMonth * 2;
  }
  return bookedByPastMonth;
};
